import {Component, EventEmitter, Output, QueryList, ViewChildren} from '@angular/core';
import {DiversityInsightService} from '../service/diversity-insight.service';
import {DiversityLegendClickEvent, DiversityTab} from '../../../../model';
import {TranslateService} from '@ngx-translate/core';
import {DiversityInsightLegendItemComponent} from './diversity-insight-legend-item/diversity-insight-legend-item.component';

@Component({
  selector: 'diversity-insight-legend',
  templateUrl: './diversity-insight-legend.component.html',
  styleUrls: ['./diversity-insight-legend.component.scss']
})
export class DiversityInsightLegendComponent {

  stageClickedCount = 3;
  numOfStages = 3;
  hiddenStages = [];
  currentDiversityTab: String;

  @Output() yearsAndQuarters = new EventEmitter<any>();
  @ViewChildren('stageItem') stageItems!: QueryList<DiversityInsightLegendItemComponent>;

  constructor(public diversityInsightService: DiversityInsightService,
              private Translate: TranslateService) {
    this.diversityInsightService.selectedDiversityTab$.subscribe(selected => {
      this.currentDiversityTab = selected.name;
      this.hiddenStages.forEach(stage => {
        this.stageClicked(selected, {label: stage, checked: false, isStage: true}, true);
      });
    });
  }

  itemClicked(event: DiversityLegendClickEvent) {
    const selected = this.diversityInsightService.selectedDiversityTab;
    if (event.isStage) {
      if (event.checked) {
        this.hiddenStages.forEach((element, index) => {
          if (element === event.label) delete this.hiddenStages[index];
        });
      } else {
        this.hiddenStages.push(event.label);
      }
      this.stageClicked(selected, event, false);
    } else {
      this.demographicClicked(selected, event);
    }
  }

  stageClicked(selected: DiversityTab, event: DiversityLegendClickEvent, skipCount: boolean) {
    const eventLabel = event.label;
    const notEnoughDataQuarterCount = this.calculateNotEnoughDataQuarterCount(selected, eventLabel);

    this.diversityInsightService.showNotEnoughInfoScreen = notEnoughDataQuarterCount === selected.data.length;

    if (!skipCount) {
      if (event.checked && this.stageClickedCount < this.numOfStages) {
        this.stageClickedCount++;
      } else if (this.stageClickedCount > 0) {
        this.stageClickedCount--;
      }
      this.diversityInsightService.selectedDiversityTab = selected;
    }
  }

  demographicClicked(selected: DiversityTab, event: DiversityLegendClickEvent) {
    this.diversityInsightService.selectedDiversityTab = selected;
  }

  updateSelectedYearsAndQuarters($event) {
    this.diversityInsightService.dateSelection = {
      years: $event.years.map((year) => year.toString()),
      quarters: $event.quarters.map((quarter) => this.Translate.instant(`diversity.quarters.q${quarter}`))
    };
  }

  getFirstCheckedStageItem(): DiversityInsightLegendItemComponent {
    return this.stageItems.filter(item => item.checkbox.checked)[0];
  }

  getReformattedDiversityLabel(label: string): string {
    let reformattedLabel = label.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase();
    if (reformattedLabel.charAt(0) === '-') {
      reformattedLabel = reformattedLabel.substring(1);
    }
    if (reformattedLabel.charAt(reformattedLabel.length - 1) === '-') {
      reformattedLabel = reformattedLabel.substring(0, reformattedLabel.length - 1);
    }
    return reformattedLabel;
  }

  calculateNotEnoughDataQuarterCount(selected: DiversityTab, eventLabel): number {
    let notEnoughDataQuarterCount = 0;
    for (const item of selected.data) {
      let notEnoughDataCount = 0;
      for (const stageItem of item.data) {

        let stageShown = this.diversityInsightService.getStageDisplayStatus(stageItem.label);
        stageShown = stageItem.label.toLowerCase().indexOf(eventLabel) >= 0 ? !stageShown : stageShown;

        if (stageItem.data[0].notEnoughData || !stageShown) {
          notEnoughDataCount += 1;
        } else if (stageShown) {
          notEnoughDataCount -= 1;
        }
      }
      item.entireNotEnoughData = notEnoughDataCount === item.data.length;
      if (item.entireNotEnoughData) {
        notEnoughDataQuarterCount += 1;
      } else {
        notEnoughDataQuarterCount -= 1;
      }
    }
    return notEnoughDataQuarterCount;
  }
}
